import { xBaseTheme } from "@eisinc/XDL/types";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        color: "primary.main",
        hoverMode: undefined,
        css: css``,
        hoverStyle: {
            textDecoration: "underline",
            color: "primary.main",
        },
    },
} as xBaseTheme["link"];
